// extracted by mini-css-extract-plugin
export var cardHeader = "_sg-0";
export var reorderHandle = "_sg-3";
export var titleArea = "_sg-1";
export var titleAreaWithHandle = "_sg-2";